import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { fetchCampusDetails } from "../../../redux/campusesSlice";
import ViewParentEngagementGModal from "./ViewParentEngagementGModal";
import toast from "react-hot-toast";

const ParentEngagementReportGroup = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const [viewReportOpen, setViewReportOpen] = useState(false);
  const [selectedCampusId, setSelectedCampusId] = useState("");
  const [selectedClassId, setSelectedClassId] = useState("");
  const [selectedSectionId, setSelectedSectionId] = useState("");
  
  const { campusDetails, loading } = useSelector((state) => state.campuses);
  
  // Add dummy classes if no classes are available from the campus
  const dummyClasses = [
    { id: "C001", className: "Grade 8" },
    { id: "C002", className: "Grade 9" },
    { id: "C003", className: "Grade 10" },
    { id: "C004", className: "Grade 11" },
    { id: "C005", className: "Grade 12" }
  ];
  
  const selectedCampus = campusDetails.find(campus => campus.id === selectedCampusId) || { classes: [] };
  const availableClasses = selectedCampus.classes && selectedCampus.classes.length > 0 
    ? selectedCampus.classes 
    : dummyClasses;
  
  const selectedClass = availableClasses.find(cls => cls.id === selectedClassId) || { sections: [] };
  
  // Add dummy sections if no sections are available from the class
  const dummySections = [
    { id: "S001", sectionName: "Section A" },
    { id: "S002", sectionName: "Section B" },
    { id: "S003", sectionName: "Section C" },
    { id: "S004", sectionName: "Section D" }
  ];
  
  const availableSections = selectedClass.sections && selectedClass.sections.length > 0 
    ? selectedClass.sections 
    : dummySections;
  
  const selectedSection = availableSections.find(section => section.id === selectedSectionId) || { students: [] };

  useEffect(() => {
    if (isOpen) {
      dispatch(fetchCampusDetails());
    }
  }, [isOpen, dispatch]);
  
  useEffect(() => {
    if (selectedCampusId === "") {
      setSelectedClassId("");
      setSelectedSectionId("");
    }
  }, [selectedCampusId]);
  
  useEffect(() => {
    if (selectedClassId === "") {
      setSelectedSectionId("");
    }
  }, [selectedClassId]);

  const handleViewSectionReport = () => {
    if (selectedSectionId) {
      setViewReportOpen(true);
    } else {
      toast.error("Please select a section first");
    }
  };

  if (!isOpen) return null;

  return (
    <>
      <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
        <div className="bg-white p-6 rounded-lg shadow-lg w-[60%] relative">
          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label htmlFor="campus" className="block mb-2">
                Campus
              </label>
              <select 
                id="campus" 
                className="border p-2 rounded w-full"
                value={selectedCampusId}
                onChange={(e) => setSelectedCampusId(e.target.value)}
                disabled={loading}
              >
                <option value="" disabled>
                  Choose a campus
                </option>
                {campusDetails.map((campus) => (
                  <option key={campus.id} value={campus.id}>
                    {campus.name}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label htmlFor="grade" className="block mb-2">
                Grade
              </label>
              <select 
                id="grade" 
                className="border p-2 rounded w-full"
                value={selectedClassId}
                onChange={(e) => setSelectedClassId(e.target.value)}
                disabled={!selectedCampusId || loading}
              >
                <option value="" disabled>
                  Choose a grade
                </option>
                {availableClasses.map((cls) => (
                  <option key={cls.id} value={cls.id}>
                    {cls.className}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-4 mt-4">
            <div>
              <label htmlFor="section" className="block mb-2">
                Section
              </label>
              <select 
                id="section" 
                className="border p-2 rounded w-full"
                value={selectedSectionId}
                onChange={(e) => setSelectedSectionId(e.target.value)}
                disabled={!selectedClassId || loading}
              >
                <option value="" disabled>
                  Choose a section
                </option>
                {availableSections.map((section) => (
                  <option key={section.id} value={section.id}>
                    {section.sectionName}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end space-x-3 mt-6">
            <button
              onClick={onClose}
              className="bg-gray-400 px-4 py-2 rounded text-white"
            >
              Close
            </button>
            <button
              onClick={handleViewSectionReport}
              className="bg-[#241763] px-4 py-2 rounded text-white"
              disabled={!selectedSectionId || loading}
            >
              View Section Report
            </button>
          </div>
        </div>
      </div>

      <ViewParentEngagementGModal
        isOpen={viewReportOpen}
        onClose={() => setViewReportOpen(false)}
        sectionId={selectedSectionId}
        sectionName={selectedSection.sectionName}
        className={selectedClass.className}
        campusName={selectedCampus.name} 
      />
    </>
  );
};

export default ParentEngagementReportGroup;